// Environment-aware logging: silent in production builds, visible in development.
const isProd = process.env.NODE_ENV === "production";

export const logWarn = (...args) => {
  if (!isProd) console.warn(...args);
};

export const logError = (...args) => {
  if (!isProd) console.error(...args);
};
